// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"base__appWrapper___GvJaX"};